import { PlusOutlined } from "@ant-design/icons";
import { contraceptionApi, healthApi } from "@api";
import {
  ComponentPagination,
  SearchFilter,
  SelectedFilter,
  SharedButton,
  StyledListPage,
  ComponentHeader,
  StyledInnerListPage,
  SharedIconButton,
  PlusIcon,
  DownloadIcon
} from "@components";

import { PATH_CREATE_DEPO_RECORDS, contraceptionFilter, enumFilter, initPage } from "@configs";
import { IClinic, IHealthClient, IPagination } from "@interfaces";

import { selectApp, setLoading } from "@redux";
import { useNotify } from "@utils";
import { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Tooltip } from "antd";
import { HealthClientTable } from "@modules";

export const PageHealthClient = () => {
  // hook
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const { success, error, info } = useNotify();
  const { mobile } = useSelector(selectApp);
  // state
  const [page, setPage] = useState<IPagination>(initPage);
  const [total, setTotal] = useState<number>(0);
  const [data, setData] = useState<IHealthClient[]>([]);
  const [filters, setFilters] = useState<enumFilter | string>("");
  const [text, setText] = useState<string>("");
  const [date, setDate] = useState<string[]>([]);

  useEffect(() => {
    fetchHealthClient();
  }, [page, text, date]);

  const fetchHealthClient = async () => {
    try {
      dispatch(setLoading(true));
      const res = await healthApi.clients({
        page: page.page,
        limit: page.limit,
        searchColumn: filters,
        search: text,
        startDate: date[0],
        endDate: date[1],
      });
      setData(res?.data?.data);
      setTotal(res.data?.nTotal);
      success(t("message.fetch.success"));
    } catch (err: any) {
      error(t("message.fetch.fail"));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };
  const handleDateFilter = (dates: null | (Dayjs | null)[], dateStrings: string[]) => {
    setDate(dateStrings);
  };
  const handlePagination = (current: number, size: number) => {
    console.log(current);
    setPage({ ...page, page: current, limit: size });
  };

  const goToCreate = () => {
    info(t("message.info.message"));
  };
  const changeFilter = (value: string) => setFilters(value);
  const searchText = (value: string) => setText(value);
  const handleClearSearch = () => {
    setText("");
    setFilters("");
  };
  const handleClearDate = () => setDate([]);



  const button = (
    <>
    <Tooltip title={t("page.add_patient_record")}>
      {mobile ? (
        <SharedIconButton type="primary" ghost icon={<PlusIcon />} onClick={goToCreate} />
      ) : (
        <SharedButton
          type="primary"
          ghost
          icon={<PlusOutlined />}
          size="middle"
          onClick={goToCreate}
        >
          {t("page.add_new")}
        </SharedButton>
      )}
    </Tooltip>
    </>
  );

  return (
    <>
      <ComponentHeader title={t("page.SRHR_Client_Data_Records")} />
      <StyledListPage>
        <StyledInnerListPage>
          <SearchFilter
            filter={contraceptionFilter}
            callbackFun={changeFilter}
            onDateChange={handleDateFilter}
            searchText={searchText}
            searchInputPlaceholder={`Search Clients by Name, Phone Number,Age...`}
            selectedOption={filters}
          />
          <SelectedFilter
            handleClearSearch={handleClearSearch}
            handleClearDate={handleClearDate}
            selected={filters}
            formDate={date[0]}
            toDate={date[1]}
          />
          <HealthClientTable data={data} callback={goToCreate} />
          <ComponentPagination total={total} page={page.page} changePage={handlePagination} />
        </StyledInnerListPage>
      </StyledListPage>
    </>
  );
};
